import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

/**
 * Do some serious clean up here.
 * Note, keep it quite flat. Nesting user is probably desirable, the way it's done below.
 * The below nested examples are not great. They show you it can be done, but rather not.
 */
export const store = new Vuex.Store({
    state: {
        counter: 0,
        user: {
            email: '',
            fooarray: [
                1,
                2
            ],
        },
        candidateSummarySideMenuOpen: false,
    },
    getters,
    mutations,
    actions,
});

